import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Calendar } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';

const StickyMobileCTA = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  const handleClick = () => {
    const offersSection = document.getElementById('offers');
    if (offersSection) {
      offersSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="fixed bottom-0 left-0 w-full z-40 bg-white border-t border-gray-200 p-4 md:hidden shadow-[0_-5px_20px_rgba(0,0,0,0.1)] animate-slide-up">
      <Button
        className="w-full bg-accent-500 hover:bg-accent-600 text-white font-bold shadow-lg"
        onClick={handleClick}
      >
        <Calendar className="w-4 h-4 mr-2" /> {t('stickyMobile.checkAvailability')}
      </Button>
    </div>
  );
};

export default StickyMobileCTA;
